import { Files } from './files.model';

export class PraRemarksResponsesModels {
  authorFullName?: string;
  authorPosition?: string;
  createdAt?: string;
  decisionDate?: string;
  decisionFiles?: Files[];
  decisionRequisites?: string;
  regActRemarkId?: string;
  regActRemarkResponseId?: string;
  updatedAt?: string;

  constructor(item: any) {
    this.authorFullName = item.authorFullName;
    this.authorPosition = item.authorPosition;
    this.createdAt = item.createdAt;
    this.decisionDate = item.decisionDate;
    this.decisionRequisites = item.decisionRequisites;
    this.regActRemarkId = item.regActRemarkId;
    this.regActRemarkResponseId = item.regActRemarkResponseId;
    this.updatedAt = item.updatedAt;
    this.decisionFiles =
      item.decisionFiles?.map((file: any) => new Files(file)) || [];
  }
}
